import { render, staticRenderFns } from "./AuthorityGroup.vue?vue&type=template&id=01382138&scoped=true&"
import script from "./AuthorityGroup.vue?vue&type=script&lang=ts&"
export * from "./AuthorityGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorityGroup.vue?vue&type=style&index=0&id=01382138&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01382138",
  null
  
)

export default component.exports